import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import sv from "./locales/sv.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import ja from "./locales/ja.json";

const KEY = "andrum.locale";

export const supportedLocales = ["sv", "en", "fr", "de", "ja"] as const;
export type Locale = (typeof supportedLocales)[number];

export function isLocale(value: string | null | undefined): value is Locale {
  return (
    value === "sv" ||
    value === "en" ||
    value === "fr" ||
    value === "de" ||
    value === "ja"
  );
}

export function detectLocale(): Locale {
  try {
    const s = localStorage.getItem(KEY);
    if (isLocale(s)) return s;
  } catch {
    /* ignore */
  }
  const nav = (navigator.language || "sv").toLowerCase();
  if (nav.startsWith("en")) return "en";
  if (nav.startsWith("fr")) return "fr";
  if (nav.startsWith("de")) return "de";
  if (nav.startsWith("ja")) return "ja";
  return "sv";
}

export function setLocale(locale: Locale) {
  try {
    localStorage.setItem(KEY, locale);
  } catch {
    /* ignore */
  }
  void i18n.changeLanguage(locale);
  document.documentElement.lang = locale;
}

export async function initI18n() {
  if (i18n.isInitialized) return i18n;
  const lng = detectLocale();
  await i18n.use(initReactI18next).init({
    resources: {
      sv: { translation: sv },
      en: { translation: en },
      fr: { translation: fr },
      de: { translation: de },
      ja: { translation: ja },
    },
    lng,
    fallbackLng: "en",
    supportedLngs: [...supportedLocales],
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
  document.documentElement.lang = lng;
  return i18n;
}

export { i18n };
